import { render } from "./readAnnounce.vue?vue&type=template&id=ab68620c"
import script from "./readAnnounce.vue?vue&type=script&lang=js"
export * from "./readAnnounce.vue?vue&type=script&lang=js"

import "./readAnnounce.vue?vue&type=style&index=0&id=ab68620c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__